import { render, staticRenderFns } from "./digipoDownloadMgm.vue?vue&type=template&id=7bc3e0b2&scoped=true&"
import script from "./digipoDownloadMgm.vue?vue&type=script&lang=js&"
export * from "./digipoDownloadMgm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3e0b2",
  null
  
)

export default component.exports